import getStudentsSlice from "./getStudentsSlice";
import getStudentDetailSlice from "./getStudentDetailSlice";
import uploadStorageSlice from "./uploadStorageSlice";
import createResourceSlice from "./createResourceSlice";
import getBookingsSlice from "./getBookingsSlice";
import getCoachSlice from "./getCoachSlice";
import getCoachResourcesSlice from "./getCoachResourcesSlice";
import updateBookingStatusSlice from "./updateBookingStatusSlice";
import createNoteSlice from "./createNoteSlice";
import getDashboardSlice from "./getDashboardSlice";
import updateStudentContactSlice from "./updateStudentContactSlice";
import scheduleSessionSlice from "./scheduleSessionSlice";
import updateCoachProfileSlice from "./updateCoachProfileSlice";
import uploadProfileImageSlice from "./uploadProfileImageSlice";
import googleIntegrationAuthSlice from "./googleIntegrationAuthSlice";
import notificationSettingsSlice from "./notificationSettingsSlice";
import accountSessionsSlice from "./accountSessionsSlice";
import signOutAccountSlice from "./signOutAccountSlice";
import locationSearchSlice from "./locationSearchSlice";
import supportTicketSlice from "./supportTicketSlice";
import globalSearchSlice from "./globalSearchSlice";
import chatSlice from "./chatSlice";
import chatListSlice from "./chatListSlice";
import signInSlice from "./signInSlice";
import resetPasswordSlice from "./resetPasswordSlice";
import changePasswordSlice from "./changePasswordSlice";
import forgotPasswordSlice from "./forgotPasswordSlice";
import integrationStatusSlice from "./integrationStatusSlice";
import getRecordingsSlice from "./getRecordingsSlice";



export const allStudentSlices = {
    getStudent: getStudentsSlice,
    getStudentDetail: getStudentDetailSlice,
    uploadStorage: uploadStorageSlice,
    createResource: createResourceSlice,
    getBookings: getBookingsSlice,
    getCoach: getCoachSlice,
    getCoachResources: getCoachResourcesSlice,
    updateBookingStatus: updateBookingStatusSlice,
    createNote: createNoteSlice,
    getDashboard: getDashboardSlice,
    updateStudentContact: updateStudentContactSlice,
    scheduleSession: scheduleSessionSlice,
    updateCoachProfile: updateCoachProfileSlice,
    uploadProfileImage: uploadProfileImageSlice,
    googleIntegrationAuth: googleIntegrationAuthSlice,
    notificationSettings: notificationSettingsSlice,
    accountSessions: accountSessionsSlice,
    signOutAccount: signOutAccountSlice,
    locationSearch: locationSearchSlice,
    supportTicket: supportTicketSlice,
    globalSearch: globalSearchSlice,
    chat: chatSlice,
    chatList: chatListSlice,
    signIn: signInSlice,
    resetPassword: resetPasswordSlice,
    changePassword: changePasswordSlice,
    forgotPassword: forgotPasswordSlice,
    integrationStatus: integrationStatusSlice,
    getRecordings: getRecordingsSlice,
};
